exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recordLocation {\n    height: 300px !important;\n    z-index: 0;\n}\n.marker-legend {\n    height: 16px;\n}\n", ""]);

// exports
